<div class="d-flex justify-content-between input-group search-filter">
	<div class="input-group-prepend"></div>
	<input class="form-control" type="text" [placeholder]="placeholder" [ngModel]="keyword"
		[ngbTypeahead]="typeAheadSearch" [inputFormatter]="inputFormatter" [resultTemplate]="rt"
		(selectItem)="typeAheadSelected($event)" [disabled]="isDisabled" />
	<div class="input-group-append">
		@if (isLoading) {
			<button class="btn btn-icon btn-info" data-cy="SearchButton" title="Search">
				<i class="fal fa-spinner fa-spin"></i>
			</button>
		} @else {
			@if (value === null) {
				<button class="btn btn-icon btn-info" data-cy="SearchButton" title="Search">
					<i class="fal fa-magnifying-glass"></i>
				</button>
			} @else {
				<button [hidden]="!keyword" type="button" class="btn btn-icon btn-remove" (click)="clearValue()"
					data-cy="ClearSearchButton" title="Clear Search">
					<i class="fal fa-xmark"></i>
				</button>
			}
		}
	</div>
</div>

<ng-template #rt let-r="result" let-t="term">
	@if (isLoadMore(r)) {
		<button class="btn btn-sm btn-link text-muted btn-load-more" (click)="loadMore($event)">
			Load more ({{ r.loaded }} of {{ r.total }})
		</button>
	} @else {
		<ngb-highlight [result]="labelFn(r)" [term]="t"></ngb-highlight>
	}
</ng-template>